// Small, dependency-free color helpers so a single user-picked accent color
// (see StudentThemeContext) can generate a full, usable palette (hover/soft/
// text shades, readable button text) instead of asking the user to pick four
// different colors themselves.

const hexToRgb = (hex) => {
  const normalized = hex.replace("#", "");
  const value =
    normalized.length === 3
      ? normalized.split("").map((c) => c + c).join("")
      : normalized;
  const int = parseInt(value, 16);
  return { r: (int >> 16) & 255, g: (int >> 8) & 255, b: int & 255 };
};

const toHex = (value) => Math.max(0, Math.min(255, Math.round(value))).toString(16).padStart(2, "0");

/** Mixes a hex color toward black by `amount` (0-1) — used for hover/text shades. */
export const darken = (hex, amount) => {
  const { r, g, b } = hexToRgb(hex);
  const mix = (channel) => channel * (1 - amount);
  return `#${toHex(mix(r))}${toHex(mix(g))}${toHex(mix(b))}`;
};

/** Returns the color as an rgba() string at the given alpha — used for soft tints. */
export const toRgba = (hex, alpha) => {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/** Perceived-luminance check so button/sidebar text stays readable on any
 * user-picked accent color, light or dark. */
export const getReadableTextColor = (hex) => {
  const { r, g, b } = hexToRgb(hex);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? "#0f172a" : "#ffffff";
};
